module.exports = __webpack_public_path__ + "static/media/zhiyezhuang1.811b0a6f.png";